/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PersonEntities } from '../../models/person-entities';

export interface IdentGetEntities$Params {
}

export function identGetEntities(http: HttpClient, rootUrl: string, params?: IdentGetEntities$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonEntities>> {
  const rb = new RequestBuilder(rootUrl, identGetEntities.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PersonEntities>;
    })
  );
}

identGetEntities.PATH = '/ident/r_entities';
